import useSWR from "swr";
import { swrKey, userFetcher } from "components/userApi";
import { Skeleton, Typography } from "@mui/material";

interface Props {
  hideIfEmpty?: boolean;
  withHonorific?: boolean;
}

export function CompanyName({hideIfEmpty = false, withHonorific = false}: Props) {
  const { data, error, isLoading } = useSWR(swrKey, userFetcher);

  if (isLoading) {
    return <Skeleton variant="text" width={150} height={24} />;
  }

  if (error) {
    return hideIfEmpty ? null : (
      <Typography color="error">読み込みエラーが発生しました。</Typography>
    );
  }

  if (!data) {
    return hideIfEmpty ? null : (
      <Typography color="text.secondary">設定されていません。</Typography>
    );
  }

  return <>{data.companyName}{withHonorific ? ' 様' : ''}</>;
}
